module.exports = __webpack_public_path__ + "static/media/typography.af74b550.svg";